/*
 * @Description: 英文
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2019-11-25 14:51:43
 * @LastEditors: 山淑兰
 */
export default {
  language: {
    name: '中文'
  },
 
  meeting:{
    header:{
      search:{
        placeholder:'Please use name or institution to search for experts',
		sort: 'Sorted alphabetically by first name',
        selectDate:'Select Date',
        selectVenue:'Select Venue',
        agenda:'Meeting Schedule',
        task:'Meeting Task',
        guestIntroduction:'Guest Introduction',
      }
    },
    details:{
      guestsIntroductionTitle:"Profile",
      guestsIntroduction:"No Data"
    }
  }
}